import React from 'react'
import { type FieldErrors } from 'react-hook-form'

import { Banner, Button, ButtonGroup } from 'slab'

import { type AdminReimbursementFormInput } from './types'

interface AdminReimbursementSubmissionButtonsProps {
  onChange: (v: boolean) => void
  errors: FieldErrors<AdminReimbursementFormInput>
  isThisEmployeeInactive: boolean
}

export const AdminReimbursementSubmissionButtons: React.FC<
  AdminReimbursementSubmissionButtonsProps
> = ({ onChange, errors, isThisEmployeeInactive }) => {
  const disableApproveSubmission = Object.keys(errors).length !== 0

  return (
    <div className='flex flex-col items-center gap-y-4'>
      {isThisEmployeeInactive && (
        <Banner
          type='warning'
          title='Member has been marked employment_status = inactive due to employer not fulfilling their healthcare bills. Please verify that member is within eligibility period before approving reimbursement.'
        />
      )}
      <ButtonGroup align='center' layout='horizontal'>
        <Button
          data-testid='approve-button'
          variant='primary'
          disabled={disableApproveSubmission}
          type='submit'
          onClick={() => onChange(true)}
        >
          Approve
        </Button>
        <Button
          data-testid='reject-button'
          variant='primary-destructive'
          type='submit'
          onClick={() => onChange(false)}
        >
          Reject
        </Button>
      </ButtonGroup>
    </div>
  )
}
